import "core-js/stable";
import * as React from "react";
import * as ReactDOM from "react-dom";
import {AppStore} from "./stores/app.store";
import {MainFrame} from "./common/mainframe";
import "./scss/main.scss";
import "./fontawesome-library/fontawesome.library";
import Cookies from "js-cookie";

export class App {
	private appStore: AppStore;

	constructor() {
		this.appStore = new AppStore();
		this.refreshTitle();
	}

	private refreshTitle() {
		document.title = `Chartered Institute of Housing`;
	}

	private addNavigationCss() {
		const cssUrl = Cookies.get("navigationCssUrl");
		if (cssUrl) {
			let link = document.createElement("link");
			link.href = cssUrl;
			link.type = "text/css";
			link.rel = "stylesheet";

			document.getElementsByTagName("head")[0].appendChild(link);
		}
	}

	async start() {
		this.addNavigationCss();
		await this.appStore.init().catch((reason) => {
			// ignore to let React get initialized
			console.error(reason);
		});
		ReactDOM.render(<MainFrame appStore={this.appStore} />, document.getElementById("root"));
	}
}
